<template>
  <a-spin :spinning="spinning" size="large">
    <div class="post-detail" v-if="detail">
      <template>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col gap">
            <span class="title">{{ detail.name }}</span>
          </a-col>
          <a-col class="col col2">
            <span class="time">
              <icon-font type="riqi" />
              更新时间：{{ detail.refreshed_at }}
            </span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <template v-if="detail.job_attribute == 2">
              <span class="salary">
                {{
                  `${detail.hunter_salary_min}-${detail.hunter_salary_max}万`
                }}</span
              >
              <a-divider type="vertical" />
            </template>
            <span>{{ detail.job_areas | formatCity }}</span>
            <a-divider type="vertical" />
            <span>招聘{{ detail.quantity }}人</span>
            <a-divider type="vertical" />
            <span>{{ detail.experience_name }}经验</span>
            <a-divider type="vertical" />
            <span>{{ detail.education_name }}</span>
          </a-col>
        </a-row>
        <a-row class="row" type="flex" justify="space-between" align="middle">
          <a-col class="col">
            <span>{{ detail.company.name }}</span>
          </a-col>
          <a-col class="col">
            被浏览：{{ detail.num_views }}人 被接单：{{ detail.count_posts }}人
          </a-col>
        </a-row>
        <a-tabs class="tabs" :defaultActiveKey="tab">
          <a-tab-pane tab="职位信息" :key="1" forceRender>
            <info :info="detail" type="job" v-if="detail.job_attribute == 2"></info>
            <div class="partTime-info" v-else>
              <p class="title">薪资待遇</p>
              <div style="color:red">{{ detail.flexible_job.basic_salary }}元 / {{basic_salary_period[detail.flexible_job.basic_salary_period]}} · {{settlement_method[detail.flexible_job.settlement_method]}}</div>
              <div>提成：{{ detail.flexible_job.bonus_value || '无' }}{{ detail.flexible_job.bonus_type==2?'%':detail.flexible_job.bonus_type==3?'元/件':'' }}</div>
              <p>福利：{{ detail.selling_point_tags.join(' ') || '无福利'}}</p>
              <p class="title">工作内容</p>
              <p v-html="detail.requirements"></p>
              <p class="title">岗位要求</p>
              <p v-html="detail.description"></p>
              <p class="title">工作地址</p>
              <p>{{detail.province_name}}{{detail.city_name}}{{detail.dist_name}}</p>
              <p class="title">人员要求</p>
              <div>性别要求：{{ config.sex[detail.gender_id] || '不限' }}</div>
              <div>学历要求：{{ config.education[detail.education_id] }}</div>
              <div>身高要求：{{ detail.flexible_job.height_requirements == 0 ? '无要求' : `${detail.flexible_job.height_requirements}CM`}}</div>
              <p>健康证：{{detail.flexible_job.health_requirements == 1 ? "无要求":"需要" }}</p>
              <p class="title">联系方式</p>
              <p>{{ contactTypeData[detail.flexible_job.contact_type] }}{{detail.flexible_job.contact_value }}</p>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="职位服务" :key="2" forceRender>
            <a-row>
              <a-col>
                <DividerBar text="招聘服务"></DividerBar>
                <div style="padding-left:30px">
                  <p v-if="detail.job_attribute == 2">
                    {{detail.recruit_service_type == 1 ? '面试快' : detail.recruit_service_type == 2 ? '入职快' : '过保快' }}服务 
                    {{detail.service_fee_type == 1 ? detail.service_fee_value + '%年薪比例' : detail.service_fee_value + '元'}}
                  </p>
                  <p v-else>
                    设置服务费
                    {{detail.service_fee_type == 1 ? detail.service_fee_value + '%年薪比例' : detail.service_fee_value + '元'}}
                  </p>
                  <p v-if="detail.hunter_commission_type == 1">
                    猎头佣金 {{detail.hunter_commission_value || 0}}%({{ detail.hunter_commission_max || 0 }}元)
                  </p>
                  <p v-else>
                    猎头佣金 {{detail.hunter_commission_value || 0}}元
                  </p>
                  <p>平台抽佣 {{detail.platform_commission_rate || 0}}%({{ detail.platform_commission_value || 0 }}元)</p>
                  <p>层级躺赚 按平台抽佣比例的 {{detail.layer_rate || 0}}%</p>
                </div>
              </a-col>
              <a-col>
                <DividerBar text="悬赏服务"></DividerBar>
                <div style="padding-left:30px">
                  <p>悬赏金额：{{detail.company_reward_amount || 0}}元</p>
                  <p>悬赏人数：{{detail.company_reward_offered_num || 0}}人</p>
                  <p>截至时间：{{detail.company_reward_deadline}}</p>
                </div>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="应聘人选" :key="3" forceRender>
            <Candidate :job_id="detail.id" v-if="detail.job_attribute == 2"></Candidate>
            <PartTimeCandidate :job_id="detail.id" :company_id="detail.company_id" v-else></PartTimeCandidate>
            <!-- <Candidate :job_id="detail.id"></Candidate> -->
          </a-tab-pane> 
        </a-tabs>
      </template>
    </div>
  </a-spin>
</template>

<script>
import PostDynamic from "./detail/postDynamic";
import Info from "./detail/info";
import Candidate from "./detail/candidate";
import PartTimeCandidate from "./detail/partTimeCandidate";
import Api from "@/api";
import DividerBar from '@/components/dividerBar'
import { mapState } from 'vuex'

export default {
  name: "postDetail",
  data() {
    return {
      detail: null,
      spinning: false,
      basic_salary_period: ['', '小时', '天', '周', '月', '次', '其他'],
      settlement_method: ['', '日结', '周结', '月结', '完工结'],
      bonus_type: ['', '无提成', '业绩提成', '计件提成', '自定义'],
      contactTypeData: ['', '微信', '微信公众号', '电话联系', 'QQ', 'QQ群', '不要主动联系我']
    };
  },
  props: {
    id: {
      default: -1
    },
    tab: {
      type: Number,
      default: 1
    }
  },
  components: { Info, PostDynamic, DividerBar, Candidate, PartTimeCandidate },
  computed: {
    ...mapState(['config']),
    post_id() {
      if (this.id < 0) {
        return this.$route.params.post_id;
      } else {
        return this.id;
      }
    }
  },
  created() {
    this.getDetail();
  },
  mounted() {},
  methods: {
    async getDetail() {
      this.spinning = true;
      let response = await Api.post.getPostInfo({ job_id: this.post_id });
      console.log(response);
      if (response.job) {
        this.detail = response.job;
        this.detail.draw_portrait_inactive_tag = this.detail.draw_portrait_inactive_tag ? JSON.parse(this.detail.draw_portrait_inactive_tag) : {};
        this.detail.draw_portrait_active_tag = this.detail.draw_portrait_active_tag ? JSON.parse(this.detail.draw_portrait_active_tag) : {};
        this.$nextTick().then(() => {
          this.spinning = false;
        });
      }
    }
  }
};
</script>

<style lang="scss">
.post-detail {
  // max-width: 1250px;
  margin: 0 30px;
  min-height: 400px;
  padding-top: 40px;
  .row {
    margin-bottom: 10px;
    &.theme {
      padding: 0 20px;
      margin: 20px 0;
      height: 46px;
      background: rgba(53, 181, 254, 0.1);
      border: 1px solid rgba(53, 181, 254, 1);
    }
    .col {
      display: flex;
      align-items: center;
      &.gap {
        span:not(:last-child) {
          margin-right: 16px;
        }
      }
      span {
        display: flex;
        align-items: center;
        &.title {
          font-size: 16px;
          font-weight: bold;
        }
        &.ji {
          font-size: 12px;
          background: #ff6b5d;
          border-radius: 2px;
          height: 18px;
          color: #fff;
          padding: 0 3px;
        }
        &.hc {
          background: #f6b502;
          padding: 0 3px;
          font-size: 12px;
          border-radius: 2px;
          height: 18px;
          color: #fff;
        }
        &.time {
          color: #999;
          .anticon {
            margin-right: 5px;
            font-size: 16px;
          }
        }
        &.salary {
          font-size: 16px;
          color: #fc5646;
        }
        .anticon {
          font-size: 18px;
          margin-right: 5px;
        }
      }
      a {
        display: inline-block;
        margin-left: 20px;
        img {
          margin-right: 5px;
        }
      }
      .ant-btn {
        margin-left: 20px;
      }
    }
  }
  .tabs {
    .ant-tabs-tab {
      font-weight: bold;
      color: #303133;
    }
  }

  .partTime-info {
    margin-top: 30px;
    p {
      margin-bottom: 25px;
      line-height: 18px;
      &.title {
        font-weight: bold;
        font-size: 16px;
        &.inline {
          float: left;
          margin-right: 5px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>
